import { useState, useEffect } from "react";

function toPersianDigits(n: number | string): string {
  return String(n).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[+d]);
}

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

const JALALI_WEEKDAYS = [
  "یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه",
];

export default function PersianClock({ ...props }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 5 * 1000);
    return () => clearInterval(timer);
  }, []);

  const weekday = JALALI_WEEKDAYS[now.getDay()];

  const h = toPersianDigits(pad(now.getHours()));
  const m = toPersianDigits(pad(now.getMinutes()));

  const dateStr = `${toPersianDigits(weekday)}، ${now.toLocaleDateString('fa-IR')}`;

  return (
    <div {...props}>
      {h}:{m} {dateStr}
    </div>
  );
}
